var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSortUpDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 30,
    viewBox: "0 0 55 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-435 -497) translate(90 161) translate(40) translate(305 336)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 29,
    x: 0.5,
    y: 0.5,
    stroke: "#24303B",
    rx: 7
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#24303B",
    d: "M34.905 18.5l4.608-4.261.918.88 3.642 3.336 1.427-1.369c-2.114-2.029-4.015-3.693-5.987-5.586-1.466 1.406-6.013 5.61-6.013 5.61l1.405 1.39zM24.5 14.767L18.843 9.5 17.429 10.717 20.672 13.726 9.5 13.726 9.5 15.685 20.672 15.685 17.429 19.03 18.843 20.5z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSortUpDark);
export default __webpack_public_path__ + "static/media/sort-up-dark.9455c690.svg";
export { ForwardRef as ReactComponent };